import React, { useState } from "react";
import "./UserDashboard.css";

const tabs = [

    "SIA Courses",
    "Available Courses",
    "Facility Course",
    "Short Courses",
    "Partner Universities",
    "New Updates",
    "Scholarships",
    "UK School Applications",
];

function UserDashboard() {
    const [activeTab, setActiveTab] = useState(tabs[0]);

    const renderContent = () => {
        switch (activeTab) {
            case "SIA Courses":
                return (
                    <div className="sia-courses">
                        <p>
                            The Security Industry Authority (SIA) licenses are essential for anyone looking to work legally and professionally in the UK’s private security sector. Whether you're just starting out or looking to upskill, SIA training opens doors to a wide range of rewarding careers.
                        </p>

                        <h3>Available SIA Courses</h3>
                        <ul>
                            <li><strong>Door Supervisor:</strong> Ideal for working in pubs, clubs, events, and licensed venues. Includes conflict management and physical intervention training.</li>
                            <li><strong>CCTV Operator (Public Space Surveillance):</strong> Prepares you to monitor surveillance systems in control rooms for public and private spaces.</li>
                            <li><strong>Security Guarding:</strong> Focuses on static security roles in retail, construction, corporate offices, and more.</li>
                            <li><strong>Close Protection:</strong> For those interested in VIP and executive protection roles (requires additional training and experience).</li>
                        </ul>

                        <h3>Career Opportunities</h3>
                        <p>
                            With an SIA license, you can work in a variety of sectors:
                        </p>
                        <ul>
                            <li>Retail security (shopping centres, supermarkets)</li>
                            <li>Event security (concerts, festivals, sports venues)</li>
                            <li>Corporate and concierge security (office buildings, hotels)</li>
                            <li>Construction site guarding</li>
                            <li>CCTV monitoring for councils, transport, and private firms</li>
                            <li>Personal protection and executive security (with experience)</li>
                        </ul>

                        <h3>Expected Salary Ranges</h3>
                        <ul>
                            <li><strong>Security Guard:</strong> £10 – £13/hour</li>
                            <li><strong>Door Supervisor:</strong> £11 – £15/hour (higher on weekends/events)</li>
                            <li><strong>CCTV Operator:</strong> £11 – £16/hour</li>
                            <li><strong>Close Protection:</strong> £150 – £400/day (freelance or contract)</li>
                        </ul>
                        <p>
                            Many roles offer overtime, night shift bonuses, and opportunities for promotion to supervisor or site manager roles.
                        </p>

                        <h3>Why Take an SIA Course?</h3>
                        <ul>
                            <li>Fast-track your way into employment (courses take 4–6 days)</li>
                            <li>High demand across the UK — especially in cities and events</li>
                            <li>Flexible work schedules (full-time, part-time, or casual)</li>
                            <li>Great for students, career changers, or those re-entering the workforce</li>
                            <li>Build confidence, communication, and conflict resolution skills</li>
                        </ul>

                        <p>
                            Whether you're looking for a stable job, a stepping stone into law enforcement, or a flexible side income — SIA training is a powerful investment in your future.
                        </p>
                    </div>
                );


            case "Available Courses":
                return (
                    <div className="available-courses">
                        <p>
                            Our training programs are designed to equip you with the skills, certifications, and confidence to thrive in high-demand industries. Whether you're looking to enter the security sector, manage facilities, or break into tech, we’ve got a course for you.
                        </p>

                        <h3>SIA Training Courses</h3>
                        <p>
                            These courses are approved by the Security Industry Authority (SIA) and are essential for working legally in the UK’s private security sector.
                        </p>
                        <ul>
                            <li><strong>Door Supervisor:</strong> Work in licensed venues, events, and nightlife security.</li>
                            <li><strong>CCTV Operator:</strong> Monitor public and private spaces using surveillance systems.</li>
                            <li><strong>Security Guarding:</strong> Secure retail, corporate, and construction environments.</li>
                        </ul>
                        <p><em>Career Outlook:</em> High demand across the UK. Entry-level roles start at £10–£13/hour with opportunities for overtime and advancement.</p>

                        <h3>Facility Management Courses</h3>
                        <p>
                            Learn how to manage buildings, safety systems, and support services in commercial and institutional environments.
                        </p>
                        <ul>
                            <li><strong>Health & Safety Compliance</strong></li>
                            <li><strong>Fire Safety & Evacuation Planning</strong></li>
                            <li><strong>Maintenance & Asset Management</strong></li>
                            <li><strong>Cleaning & Environmental Services</strong></li>
                        </ul>
                        <p><em>Career Outlook:</em> Facility managers and supervisors are in demand in schools, hospitals, offices, and industrial sites. Salaries range from £22,000 to £45,000+ depending on experience.</p>

                        <h3>Software & Digital Skills Training</h3>
                        <p>
                            Future-proof your career with hands-on training in today’s most in-demand tech tools and platforms.
                        </p>
                        <ul>
                            <li><strong>Microsoft Office Suite (Excel, Word, PowerPoint)</strong></li>
                            <li><strong>Digital Marketing & SEO Fundamentals</strong></li>
                            <li><strong>Web Development (HTML, CSS, JavaScript)</strong></li>
                            <li><strong>Fullstack Web App & Mobile App Development</strong></li>
                            <li><strong>Basic to Advance Programming: Java, C++, C#, Python, Linux, Github, React, Angular etc. </strong></li>
                        </ul>
                        <p><em>Career Outlook:</em> Digital skills are essential across all industries. Entry-level roles in admin, marketing, and tech support start at £22,000–£30,000/year, with rapid growth potential.</p>

                        <h3>Why Choose Our Courses?</h3>
                        <ul>
                            <li>Industry-recognized certifications</li>
                            <li>Flexible learning options (in-person & online)</li>
                            <li>Career support and job placement assistance</li>
                            <li>Affordable pricing with scholarship options</li>
                            <li>Taught by experienced professionals</li>
                        </ul>

                        <p>
                            Whether you're starting fresh, switching careers, or upskilling for a promotion — our courses are designed to help you succeed.
                        </p>
                    </div>
                );

            case "Facility Course":
                return (
                    <div className="facility-course">
                        <p>
                            Facility Management is a rapidly growing field that ensures the functionality, safety, and efficiency of built environments — from office buildings and schools to hospitals and industrial sites.
                        </p>

                        <h3>What You’ll Learn</h3>
                        <ul>
                            <li><strong>Health & Safety Compliance:</strong> Understand UK regulations and how to implement them in real-world settings.</li>
                            <li><strong>Fire Safety & Emergency Planning:</strong> Learn how to assess risks and create evacuation strategies.</li>
                            <li><strong>Maintenance & Asset Management:</strong> Manage building systems, equipment, and service contracts.</li>
                            <li><strong>Cleaning & Environmental Services:</strong> Oversee hygiene, sustainability, and waste management protocols.</li>
                            <li><strong>Soft Skills:</strong> Leadership, communication, and team coordination in facility operations.</li>
                        </ul>

                        <h3>Career Opportunities</h3>
                        <p>
                            Facility managers are essential in nearly every sector. You can work in:
                        </p>
                        <ul>
                            <li>Hospitals and healthcare facilities</li>
                            <li>Schools, colleges, and universities</li>
                            <li>Corporate offices and business parks</li>
                            <li>Manufacturing and logistics centers</li>
                            <li>Residential and commercial property management</li>
                        </ul>

                        <h3>Salary Expectations</h3>
                        <p>
                            Entry-level roles start around <strong>£22,000–£28,000/year</strong>, while experienced facility managers can earn <strong>£40,000–£60,000+</strong> depending on location and sector.
                        </p>

                        <h3>Why Choose Facility Management?</h3>
                        <ul>
                            <li>High job security and demand across the UK</li>
                            <li>Opportunities for leadership and specialization</li>
                            <li>A dynamic role that combines technical and people skills</li>
                            <li>Ideal for those who enjoy problem-solving and operations</li>
                        </ul>

                        <p>
                            Whether you're transitioning from another industry or starting fresh, our Facility Management course gives you the tools to lead and succeed.
                        </p>
                    </div>
                );

            case "Short Courses":
                return (
                    <div className="short-courses">
                        <p>
                            Our short courses are designed for rapid upskilling — perfect for professionals, students, and career changers who want to gain practical knowledge in a short time. These programs are hands-on, industry-relevant, and focused on real-world application.
                        </p>

                        {/*   <h3>21-Days IoT & Electronics Hardware Design Workshop</h3>
                        <p>
                            This intensive workshop is ideal for aspiring engineers, tech enthusiasts, and innovators who want to dive into the world of smart devices and embedded systems.
                        </p>
                        <ul>
                            <li><strong>Duration:</strong> 21 days (full-time or part-time options)</li>
                            <li><strong>Topics Covered:</strong></li>
                            <ul>
                                <li>Introduction to IoT architecture and protocols</li>
                                <li>Microcontroller programming (Arduino, ESP32)</li>
                                <li>Sensor integration and data acquisition</li>
                                <li>PCB design and prototyping</li>
                                <li>Wireless communication (Wi-Fi, Bluetooth, LoRa)</li>
                                <li>Cloud connectivity and real-time dashboards</li>
                            </ul>
                            <li><strong>Project:</strong> Build and present a working IoT prototype</li>
                        </ul>
                        <p><em>Career Outlook:</em> IoT and embedded systems are booming fields. Graduates can pursue roles in hardware design, automation, smart home tech, and industrial IoT — with entry-level salaries starting at £28,000–£40,000/year.</p>

                        <h3>Other Popular Short Courses</h3>
                        <ul>
                            <li><strong>Digital Marketing Bootcamp:</strong> Learn SEO, social media strategy, and Google Ads in 5 days.</li>
                            <li><strong>Excel for Business:</strong> Master formulas, pivot tables, and dashboards in just 3 days.</li>
                            <li><strong>Fire Safety & Risk Assessment:</strong> Essential for facility managers and safety officers.</li>
                            <li><strong>Customer Service Excellence:</strong> Build communication and conflict resolution skills.</li>
                            <li><strong>Basic to Advance  Java. C++, Python, C# and Typescript</strong> A beginner-friendly coding course for data and automation.</li>
                        </ul>

                        <h3>Why Choose Our Short Courses?</h3>
                        <ul>
                            <li>Learn practical skills in days, not months</li>
                            <li>Taught by industry professionals with real-world experience</li>
                            <li>Includes certificates of completion and project-based learning</li>
                            <li>Great for CV enhancement, job interviews, and promotions</li>
                            <li>Affordable and flexible — evenings and weekend options available</li>
                        </ul>

                        <p>
                            Whether you're looking to explore a new field, sharpen your skills, or build a portfolio project — our short courses are the perfect launchpad.
                        </p> */}
                    </div>
                );


            case "Partner Universities":
                return (
                    <div className="partner-universities">
                        <p>
                            We are proud to collaborate with a network of reputable universities across the UK and internationally. Through our direct partnerships, we support both local and international students in securing admission into undergraduate, postgraduate, and professional programs.
                        </p>

                        <h3>UK University Partnerships</h3>
                        <p>
                            As a registered PRN learning provider, we maintain direct relationships with local UK universities. This allows us to guide students through the application process, provide academic preparation, and ensure a smooth transition into higher education.
                        </p>
                        <ul>
                            <li>Foundation and access programs for students without traditional qualifications</li>
                            <li>Undergraduate and postgraduate admissions support</li>
                            <li>Guidance on student finance, accommodation, and visa requirements</li>
                            <li>Fast-track application processing through our institutional links</li>
                        </ul>

                        <h3>International University Access</h3>
                        <p>
                            In addition to the UK, we also support students seeking admission to universities in:
                        </p>
                        <ul>
                            <li>Switzerland</li>
                            <li>Republic of Ireland</li>
                            <li>Northern Ireland</li>
                            <li>Canada</li>
                            <li>Germany</li>
                            <li>United States</li>
                        </ul>
                        <p>
                            Whether you're pursuing a degree in business, engineering, healthcare, IT, or the arts — we can help you find the right institution and program that fits your goals.
                        </p>

                        <h3>How We Support You</h3>
                        <ul>
                            <li>Personalized admission counseling and course selection</li>
                            <li>Application and documentation assistance</li>
                            <li>Statement of purpose (SOP) and reference letter guidance</li>
                            <li>Visa and immigration support for international students</li>
                            <li>Ongoing mentorship from application to enrollment</li>
                        </ul>

                        <h3>Who Can Apply?</h3>
                        <p>
                            We welcome applications from:
                        </p>
                        <ul>
                            <li>Local UK students seeking university admission or transfers</li>
                            <li>International students looking to study in the UK or abroad</li>
                            <li>Mature learners returning to education</li>
                            <li>Professionals seeking career advancement through further study</li>
                        </ul>

                        <p>
                            Whether you're applying for the first time or looking to continue your academic journey abroad, our team is here to guide you every step of the way.
                        </p>
                    </div>
                );

            case "New Updates":
                return (
                    <div className="new-updates">
                        <p>
                            Stay ahead of the curve with our latest updates on education, training, and international opportunities. We regularly share important news that affects learners, job seekers, and professionals — both in the UK and abroad.
                        </p>

                        <h3>Course Launches & Enrollment Windows</h3>
                        <ul>
                            <li>New short courses and workshops added every quarter</li>
                            <li>Enrollment deadlines for SIA, Facility Management, and Software Training programs</li>
                            <li>Special bootcamps and seasonal training events</li>
                            <li>New online and hybrid learning options for remote learners</li>
                        </ul>

                        <h3>Education & Funding Policy Changes</h3>
                        <p>
                            We keep you informed about changes in UK education policy that may affect your learning journey:
                        </p>
                        <ul>
                            <li>Updates on Advanced Learner Loans and government funding eligibility</li>
                            <li>Changes to qualification frameworks and assessment standards</li>
                            <li>The Office of Qualifications and Examinations Regulation (Ofqual)  and SIA regulatory updates</li>
                            <li>Trends in employability and skills demand across sectors</li>
                        </ul>

                        <h3>International Student & Visa News</h3>
                        <p>
                            For students planning to study abroad, we share timely updates on:
                        </p>
                        <ul>
                            <li>UK student visa policy changes and CAS issuance timelines</li>
                            <li>Canada and 🇺🇸 USA study permit updates</li>
                            <li>Germany and Ireland international admissions news</li>
                            <li>Application deadlines and scholarship announcements from partner universities</li>
                        </ul>

                        <h3>Industry & Career Insights</h3>
                        <p>
                            We also share insights into the job market and emerging career paths:
                        </p>
                        <ul>
                            <li>In-demand skills in security, tech, and facility management</li>
                            <li>Salary trends and job growth forecasts</li>
                            <li>Employer partnerships and internship opportunities</li>
                            <li>Guest speaker events and alumni success stories</li>
                        </ul>

                        <h3>How to Stay Updated</h3>
                        <ul>
                            <li>Subscribe to our monthly newsletter</li>
                            <li>Follow us on social media for real-time updates</li>
                            <li>Check this dashboard regularly for announcements</li>
                            <li>Join our WhatsApp or Telegram broadcast list</li>
                        </ul>

                        <p>
                            Whether you're a student, parent, or partner — staying informed helps you make smarter decisions and seize new opportunities as they arise.
                        </p>
                    </div>
                );




            case "Scholarships":
                return <p>Discover scholarship opportunities and funding support for eligible learners.</p>;


            case "UK School Applications":
                return <p>Get help applying to UK colleges and universities with our expert guidance.</p>;



            default:
                return null;
        }
    };

    return (
        <>
        <div>
            <h1> Welcome to Your Dashboard</h1>
        </div>
        <div className="dashboard-container">

            <div className="tabs-container">
                {tabs.map((tab) => (
                    <button
                        key={tab}
                        className={`tab-button ${activeTab === tab ? "active" : ""}`}
                        onClick={() => setActiveTab(tab)}
                    >
                        {tab}
                    </button>
                ))}
            </div>

            <div className="tab-content">
                <h2>{activeTab}</h2>
                <div className="tab-description">{renderContent()}</div>
            </div>
        </div>
        </>
    );
}

export default UserDashboard;
